// Curated Google Fonts library — keep in sync with FeedFonts::FONT_GROUPS in app/poro/feed_fonts.rb
export const FONT_GROUPS: [string, string[]][] = [
  ['Display', ['Abril Fatface', 'Archivo Black', 'Bebas Neue', 'Josefin Sans', 'Oswald']],
  [
    'Sans Serif',
    [
      'Barlow', 'Cabin', 'DM Sans', 'Figtree', 'Inter', 'Karla', 'Lato', 'Manrope',
      'Montserrat', 'Nunito', 'Open Sans', 'Outfit', 'Plus Jakarta Sans', 'Poppins',
      'Raleway', 'Roboto', 'Rubik', 'Source Sans Pro', 'Work Sans',
    ],
  ],
  [
    'Serif',
    [
      'Bitter', 'Cormorant Garamond', 'Crimson Text', 'EB Garamond',
      'Libre Baskerville', 'Lora', 'Merriweather', 'Playfair Display', 'Source Serif 4',
    ],
  ],
  ['Monospace', ['JetBrains Mono', 'Space Mono']],
]

export const ALL_FONTS = FONT_GROUPS.flatMap(([, fonts]) => fonts)

export const DEFAULT_FONT = 'Open Sans'

/** Build a Google Fonts CSS URL for the given font names */
export function googleFontsUrl(fonts: string[]): string {
  const unique = [...new Set(fonts.filter(Boolean))]
  if (unique.length === 0) return ''
  const families = unique.map((f) => `family=${f.replace(/ /g, '+')}:wght@400;600;700`).join('&')
  return `https://fonts.googleapis.com/css2?${families}&display=swap`
}

/** Build a Google Fonts CSS URL for ALL available fonts (for dropdown preview) */
export function allFontsUrl(): string {
  return googleFontsUrl(ALL_FONTS)
}

/** Get the CSS fallback for a font based on its group */
export function fontFallback(fontName: string): string {
  for (const [group, fonts] of FONT_GROUPS) {
    if (fonts.includes(fontName)) {
      if (group === 'Serif') return 'serif'
      if (group === 'Monospace') return 'monospace'
      return 'sans-serif'
    }
  }
  return 'sans-serif'
}
